import { Box } from '@mui/material';
import React from 'react';
import { StandardHeaderTextType } from '../../../models/ContentManagementInterface';
import { htmlToTextContent } from '../../../services/htmlToTextContent';
import { contentNotSet } from '../../../services/TemplateUtils';
import { textContentToHtml } from '../../../services/textContentToHtml';
import BlockFootnotesEditor from './BlockFootnotesEditor';
import InlineRichText from './InlineRichText';
import InlineSectionHeader from './InlineSectionHeader';
import { webBodySx } from './webTextStyles';

interface StandardHeaderBlockEditorProps {
  block: StandardHeaderTextType;
  onChange: (props: StandardHeaderTextType['properties']) => void;
  /** Shows the Footnotes panel — toggled from a button in this block's toolbar strip. */
  footnotesOpen?: boolean;
}

export default function StandardHeaderBlockEditor({
  block,
  onChange,
  footnotesOpen = false,
}: StandardHeaderBlockEditorProps) {
  const { properties } = block;
  const contentHtml = textContentToHtml(properties.content);
  const contentUnset = contentNotSet({ id: 'x', content: contentHtml });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
      <InlineSectionHeader
        heading={properties.heading}
        onChange={(heading) => onChange({ ...properties, heading })}
      />
      <InlineRichText
        html={contentHtml}
        unset={contentUnset}
        onChange={(html) => onChange({ ...properties, content: htmlToTextContent(html, true) })}
        placeholder="Add content"
        ariaLabel="Content"
        minLines={3}
        sx={webBodySx}
      />
      {footnotesOpen && (
        <BlockFootnotesEditor
          footnotes={properties.footnotes}
          onChange={(footnotes) => onChange({ ...properties, footnotes })}
        />
      )}
    </Box>
  );
}
